/**
 * Creates a deep link URL for opening a native chat with a user or group.
 *
 * @param target - The type of chat target.
 * @param id - The user or group identifier to include in the URL.
 * @returns A native app chat URL with the target ID URL-encoded.
 */
export function createNativeChatUrl(target: 'user' | 'group', id: string) {
  return `jebelapp://chat/${target}/${encodeURIComponent(id)}`;
}
